import React, { ReactElement, useMemo } from 'react';
import { useIntl, MessageDescriptor } from 'react-intl';

import TooltipMui from '@mui/material/Tooltip';
import { TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip';

export interface TooltipProps extends Omit<MuiTooltipProps, 'title'> {
  children: ReactElement;
  t?: string | MessageDescriptor | ReactElement | null | undefined | boolean;
  disabled?: boolean;
  title?: MuiTooltipProps['title'];
}

const Tooltip = ({ children, t = '', disabled = false, title, ...rest }: TooltipProps): ReactElement => {
  const intl = useIntl();
  const currentTitle = title || t;

  // Tooltip title. Zero-length titles string is never displayed.
  const computedTitle = useMemo(() => {
    // Otherwise, compute from t prop
    if (disabled) return '';
    if (currentTitle === null) return '';
    if (['undefined', 'boolean'].includes(typeof currentTitle)) return '';
    if (!React.isValidElement(currentTitle)) {
      if (typeof currentTitle === 'object') return intl.formatMessage(currentTitle as MessageDescriptor);
    }

    return currentTitle as string | React.ReactElement;
  }, [currentTitle, intl, disabled]);

  return (
    <TooltipMui title={computedTitle} arrow {...rest}>
      {children}
    </TooltipMui>
  );
};

export default Tooltip;
